<template>
  <transition
    name="bounce"
    appear
  >
    <div
      v-show="show"
      class="owal loading modal container fixed"
    >
      <div
        v-show="show"
      >
        <slot
          class="owal loading modal content"
          name="content"
        />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OwalModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.owal.loading.modal.container.fixed {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.owal.loading.modal.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  z-index: 800;
  background: rgba(0, 0, 0, 0.5);
}

.owal.loading.modal.container {
  /* Safari supports this. Chrome requires a flag to be enabled. */
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.5);
}

.fade-enter-active {
  animation: fade-in .5s;
}

.fade-leave-active {
  animation: fade-in .5s reverse;
}

.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

</style>
